$(document).ready(function(){
  //   if ($(window).width() < 767) {
  //         var remove_space_after = $(".product-details .jdgm-prev-badge__text").text();
  //         var removed_by_five = remove_space_after.split(" ");
  //         $(".product-details .jdgm-prev-badge__text").text(removed_by_five[0]);

  //         var remove_space_after_1 = $(".one-third.column .jdgm-prev-badge__text",this).text();
  //         var removed_by_five_1 = remove_space_after_1.split(" ");
  //         $(".one-third.column .jdgm-prev-badge__text",this).text(removed_by_five_1[0]);

  //   }
  jQuery(".button_class_sett_00 button").click( function() {
    jQuery(".display_unset_none button").click();
  });

});